<template>
  <article class="about-section" :class="bgClass">
    <div class="block-wrapper page-common" :class="blockWrapperClass">
      <!-- <img
        class="<ipad:hidden h-full"
        :style="{ width: imgWidth }"
        v-if="imgPosition === 'left'"
        :src="img"
        :alt="imgAlt"
      /> -->
      <div class="desktop:(w-1/2) tablet:(w-2/3)" :class="imgPositionClass,imgClass">
        <img :class="imgClass" :src="img" :alt="imgAlt" />
      </div>
      <div class="content-wrapper desktop:(w-1/2)">
        <!-- <div class="section-title">{{ sectionTitle }}</div> -->
        <!-- <div class="content">
          <h3 class="title">{{ title }}</h3>
          <slot name="content" />
        </div> -->
        <div class="title-wrapper">
          <div class="section-title" :class="titleBgClass">{{ sectionTitle }}</div>
          <h3 class="title" :class="titleStyle">{{ title }}</h3>
        </div>
        <div class="content">
          <slot name="content" />
        </div>
        <!-- <img class="ipad:hidden" :src="img" :alt="imgAlt" /> -->
        <!-- <div class="desktop:hidden flex justify-center mt-[15px]">
          <img :class="imgClass" :src="img" :alt="imgAlt" />
        </div> -->
      </div>

      <!-- <img
        class="<ipad:hidden h-full"
        :style="{ 'max-width': imgWidth }"
        v-if="imgPosition === 'right'"
        :src="img"
        :alt="imgAlt"
      /> -->
      <!-- <div v-if="imgPosition === 'right'" class="<desktop:hidden desktop:(w-1/2 pl-[70px])">
        <img :class="imgClass" :src="img" :alt="imgAlt" />
      </div> -->
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'
const props = defineProps({
  sectionTitle: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
  img: {
    type: Image,
    default: '',
  },
  imgAlt: {
    type: String,
    default: '',
  },
  imgWidth: {
    type: String,
    default: '100%',
  },
  imgPosition: {
    type: String,
    default: 'left',
  },
  bg: {
    type: String,
    default: 'default',
  },
  imgClass: {
    type: String,
    default: '',
  }
})

const bgClass = computed(() => {
	return {
    'bg': props.bg === 'purple',
  }
})

const titleBgClass = computed(() => {
	return {
    'bg-purple': props.bg === 'purple',
    'bg-green':  props.bg === 'green',
  }
})

const titleStyle = computed(() => {
  return {
    'purple': props.bg === 'purple',
    'green': props.bg === 'green',
  }
})

const blockWrapperClass = computed(() => {
  return {
    'block-row-reverse': props.imgPosition === 'right',
  }
})

const imgPositionClass = computed(() => {
  return {
    'desktop:(pr-[70px])': props.imgPosition === 'left',
    'desktop:(pl-[70px])': props.imgPosition === 'right',
  }
})
</script>

<style scoped lang="postcss">
.about-section {
  /* @apply flex flex-row gap-[40px] justify-center; */
  /* @apply <ipad:(m-auto justify-between); */
}
.block-wrapper {
  @apply flex items-center flex-col-reverse py-[20px];
  @apply desktop:(flex-row justify-between py-[40px]);
}
.block-row-reverse {
  @apply desktop:(!flex-row-reverse);
}
.title-wrapper {
  @apply flex flex-col gap-[9px] mb-[4px];
  @apply desktop:(gap-[20px] mb-[20px]);
}
.section-title {
  @apply bg-primary-100 text-white px-[25px] py-[13px] w-[fit-content] rounded-[8px];
  @apply <laptop:(px-[20px] py-[8px])
  @apply text-[16px] font-medium leading-[1] tracking-[1px];
  @apply laptop:(text-[28px] mb-0 rounded-full);
}

.title {
  @apply text-[24px] leading-[1] tracking-[1px] font-bold;
  @apply laptop:(text-[40px] tracking-[5px]);
}

.content-wrapper {
  @apply text-left;
  /* @apply desktop:(text-left); */
  @apply <desktop:(mb-[40px]);
  @apply <tablet:(mb-[16px]);
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    @apply mt-[18.93px] w-[75%]
  }
}
.content {
  @apply text-[14px] leading-[1.77] tracking-[1px] font-medium;
  @apply laptop:(text-[26px] leading-[1.6] tracking-[0.9px]);
}
.bg {
  @apply bg-primary-200;
}
.bg-purple {
  @apply bg-primary-100;
}
.purple {
  @apply text-primary-100;
}
.bg-green {
  @apply bg-secondary-100;
}
.green {
  @apply text-secondary-100;
}

img {
  @apply tablet:(max-w-[100%]);
}
</style>
